
      import Template7 from 'template7';
      const Template7Helpers = Template7.helpers;
  
      
  
      export default {
  data() {
    return {
      lng: lng,
      orders: []
    };
  },

  mounted() {
    this.$('.no-orders').addClass('hidden');
  },

  on: {
    pageBeforeIn(e, page) {
      this.getOrders();
    }

  },
  methods: {
    goTo(url) {
      this.$router.navigate(url);
    },

    getOrders() {
      const self = this,
            app = this.$app,
            $ = this.$;
      app.preloader.show();
      myApp.server.get('imc/orders').then(succ => {
        console.log(succ);
        self.$setState({
          orders: succ
        });
      }).catch(err => {
        console.log(err);
        app.toast.show({
          text: lng.genericError,
          closeTimeout: 3000,
          cssClass: 'bg-color-red',
          position: 'bottom'
        });
      }).finally(() => {
        app.preloader.hide();
        $('.no-orders').removeClass('hidden');
      });
    }

  },
  id: '958a8f5aa1',

  render() {
    return function (ctx_1, data_1, root) {
      function isArray(arr) {
        return Array.isArray(arr);
      }

      function isFunction(func) {
        return typeof func === 'function';
      }

      function c(val, ctx) {
        if (typeof val !== "undefined" && val !== null) {
          if (isFunction(val)) {
            return val.call(ctx);
          } else return val;
        } else return "";
      }

      root = root || ctx_1 || {};
      var r = '';
      r += '\n  <div class="page">\n    <div class="navbar">\n      <div class="navbar-bg"></div>\n      <div class="navbar-inner sliding">\n        <div class="left">\n          <a href="#" class="link back">\n            <i class="icon icon-back"></i>\n            <span class="if-not-md">Back</span>\n          </a>\n        </div>\n        <div class="title">';
      r += c(ctx_1.lng.myOrders, ctx_1);
      r += '</div>\n        <div class="right">\n          <a href="/">\n            <i class="icon f7-icons">house</i>\n          </a>\n        </div>\n      </div>\n    </div>\n    <div class="page-content bg-color-white">\n      <div class="block">\n        <div class="list pt-0 no-hairline no-hairline-bottom no-hairline-top">\n          <ul>\n            ';
      r += Template7Helpers.each.call(ctx_1, ctx_1.orders, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '\n            <li class="row border-bottom padding-vertical-half" @click="goTo(\'/myorder/';
          r += c(ctx_2.id, ctx_2);
          r += '/\')">\n              <div class="col-25"><small>';
          r += Template7Helpers.js.call(ctx_2, "new Date(this.dt * 1000).toLocaleString()", {
            hash: {},
            data: data_2 || {},
            fn: function empty() {
              return '';
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += '</small></div>\n              <div class="col-45">\n                ';
          r += c(ctx_2.poi_name, ctx_2);
          r += ' <br>\n                <small class=\'myorder-address\'>';
          r += c(ctx_2.poi_address, ctx_2);
          r += ' ';
          r += c(ctx_2.poi_city, ctx_2);
          r += '</small>\n                ';
          r += Template7Helpers.js_if.call(ctx_2, "this.dt != this.dt1", {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += '\n                <br><strong><small>';
              r += Template7Helpers.js.call(ctx_3, "new Date(this.dt1 * 1000).toLocaleString()", {
                hash: {},
                data: data_3 || {},
                fn: function empty() {
                  return '';
                },
                inverse: function empty() {
                  return '';
                },
                root: root,
                parents: [ctx_2, ctx_1]
              });
              r += '</small></strong>\n                ';
              r += Template7Helpers.js_if.call(ctx_3, "this.mode === 'delivery'", {
                hash: {},
                data: data_3 || {},
                fn: function empty() {
                  return '';
                },
                inverse: function empty() {
                  return '';
                },
                root: root,
                parents: [ctx_2, ctx_1]
              });
              return r;
            },
            inverse: function (ctx_3, data_3) {
              var r = '';
              r += '\n                ';
              r += Template7Helpers.js_if.call(ctx_3, "this.mode === 'delivery'", {
                hash: {},
                data: data_3 || {},
                fn: function (ctx_4, data_4) {
                  var r = '';
                  r += '\n                <br><strong><small>';
                  r += c(root.lng.order_text_2, ctx_4);
                  r += '</small></strong>\n                ';
                  return r;
                },
                inverse: function empty() {
                  return '';
                },
                root: root,
                parents: [ctx_2, ctx_1]
              });
              r += '\n                ';
              return r;
            },
            root: root,
            parents: [ctx_1]
          });
          r += '\n                \n              </div>\n              <div class="col-30 text-align-right">\n                ';
          r += c(ctx_2.currency, ctx_2);
          r += ' ';
          r += c(ctx_2.price, ctx_2);
          r += ' <br> \n                <small class=\'text-capitalize ordermode-';
          r += c(ctx_2.mode, ctx_2);
          r += '\'>';
          r += c(ctx_2.mode, ctx_2);
          r += '</small> <br>\n                ';
          r += Template7Helpers.if.call(ctx_2, ctx_2.price, {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += Template7Helpers.if.call(ctx_3, ctx_3.pay, {
                hash: {},
                data: data_3 || {},
                fn: function (ctx_4, data_4) {
                  var r = '';
                  r += '<span class="text-color-green">PAGATO</span>';
                  return r;
                },
                inverse: function (ctx_4, data_4) {
                  var r = '';
                  r += '<span class="text-color-red">DA PAGARE</span>';
                  return r;
                },
                root: root,
                parents: [ctx_2, ctx_1]
              });
              return r;
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += '\n              </div>\n              <div class="col-100 orderstatus-';
          r += c(ctx_2.status, ctx_2);
          r += '">\n                <small>';
          r += Template7Helpers.js.call(ctx_2, "lng.orderStatus[this.status]", {
            hash: {},
            data: data_2 || {},
            fn: function empty() {
              return '';
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += ' </small>\n              </div>\n            </li>\n            ';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '\n          </ul>\n        </div>\n        ';
      r += Template7Helpers.js_if.call(ctx_1, "this.orders.length == 0", {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '\n        <div class="no-orders hidden">\n          <img width="50%" src="static/no_data.svg">\n          <h2>';
          r += c(ctx_2.lng.noOrders, ctx_2);
          r += '</h2>\n        </div>\n        ';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '\n      </div>\n    </div>\n  </div>\n';
      return r;
    }(this);
  },

  styleScoped: false
};
    